var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H12V7.9L14 5.9V0ZM0 0H2V16H0V0ZM6 0H8V4H6V0ZM6 6H8V10H6V6ZM6 12H8V16H6V12ZM18.56 8.59L17.41 7.44C17.2714 7.29971 17.1064 7.18833 16.9244 7.1123C16.7424 7.03628 16.5472 6.99714 16.35 6.99714C16.1528 6.99714 15.9576 7.03628 15.7756 7.1123C15.5936 7.18833 15.4286 7.29971 15.29 7.44L10 12.73V16H13.27L18.56 10.71C19.15 10.12 19.15 9.17 18.56 8.59ZM12.58 14.45H11.55V13.42L15 9.97L16.03 11L12.58 14.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracker);
export default __webpack_public_path__ + "static/media/Tracker.83783b66e00451038b591eda5f09538a.svg";
export { ForwardRef as ReactComponent };